import React from 'react';

import { Modal } from 'src/components/common';
import { PermissiblePurposeCreateModalForm } from 'src/components/permissiblePurpose';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

export const PermissiblePurposeCreateModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen } = useModal(ModalId.PermissiblePurposeCreateModal);

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Credential to a new Permissible Purpose"
      headerPadding="32px 32px 0 32px"
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
      maxWidth={540}
    >
      <PermissiblePurposeCreateModalForm
        closeModal={onCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
